<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.title"
        placeholder="标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in NEWS_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in NEWS_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-select
        v-model="listQuery.category"
        placeholder="类目"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in NEWS_CATEGORY"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-select
        v-model="listQuery.isPop"
        placeholder="是否弹窗"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in YES_NO_LIST"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" @click="clickNews('CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">资讯数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="标题"
        align="center"
        prop="title"
      ></el-table-column>
      <el-table-column label="作者" align="center" prop="name" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "作者已失效" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="副标题"
        align="center"
        prop="subTitle"
        width="200px"
      ></el-table-column>
      <el-table-column label="内容" align="center" prop="content" width="300px">
        <template slot-scope="scope">
          <div v-html="scope.row.content" class="content-preview"></div>
        </template>
      </el-table-column>
      <el-table-column
        label="封面图"
        prop="coverImage"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="scope.row.coverImage"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="媒体类型"
        width="100px"
      >
        <template slot-scope="scope">
          <span>{{ getValue(MEDIA_TYPE, scope.row.mediaType) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="浏览次数"
        align="center"
        prop="browses"
      ></el-table-column>
      <el-table-column
        label="赞次数"
        align="center"
        prop="ups"
      ></el-table-column>
      <el-table-column
        label="踩次数"
        align="center"
        prop="downs"
      ></el-table-column>
      <el-table-column
        label="收藏次数"
        align="center"
        prop="collects"
      ></el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(NEWS_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(NEWS_TYPE, scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="category"
        label="类目"
        width="200px"
      >
        <template slot-scope="scope">
          <span>{{ getValue(NEWS_CATEGORY, scope.row.category) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="isPop"
        label="是否弹窗"
        width="200px"
      >
        <template slot-scope="scope">
          <span>{{ getValue(YES_NO_LIST, scope.row.isPop) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="280"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="clickNews('UPDATE', scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="确认切换"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            :title="`确定${scope.row.status === 0 ? '显示' : '隐藏'}该资讯吗？`"
            @confirm="checkNewsStatus(scope.row)"
            style="margin: 0 12px;"
          >
            <el-button slot="reference" type="text" size="mini">
              {{ scope.row.status === 0 ? "显示" : "隐藏" }}
            </el-button>
          </el-popconfirm>
          <el-button
            type="text"
            size="mini"
            class="danger-action"
            :loading="deletingId === scope.row.id"
            @click="deleteItem(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { deleteNews, getNewsList, updateNewsStatus } from "@/api/news.js";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  NEWS_TYPE,
  NEWS_STATUS,
  MEDIA_TYPE,
  YES_NO_LIST,
  NEWS_CATEGORY
} from "@/utils/enumUtile";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    NEWS_TYPE() {
      return NEWS_TYPE;
    },
    NEWS_STATUS() {
      return NEWS_STATUS;
    },
    MEDIA_TYPE() {
      return MEDIA_TYPE;
    },
    YES_NO_LIST() {
      return YES_NO_LIST;
    },
    NEWS_CATEGORY() {
      return NEWS_CATEGORY;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      deletingId: null,
      listQuery: {
        page: 1,
        pageSize: 20,
        title: null,
        type: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      return getNewsList(params)
        .then(response => {
          this.list = (response.data && response.data.entitys) || [];
          this.total = (response.data && response.data.totalCount) || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到新增 or 编辑
     */
    clickNews(type, row = {}) {
      if (type === "CREATE") {
        this.$router.push({ path: "/businessNews/save" });
      } else {
        this.$router.push({ path: "/businessNews/edit/" + row.id });
      }
    },

    /**
     * 切换活动状态
     */
    checkNewsStatus(item) {
      const params = {
        id: item.id,
        status: item.status === 0 ? 1 : 0
      };
      updateNewsStatus(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.getList();
          this.$notify({
            title: "成功",
            message: "切换成功",
            type: "success",
            duration: 2000
          });
        }
      });
    },
    async deleteItem(item) {
      try {
        await this.$confirm(
          `删除后无法恢复，确定删除资讯“${item.title}”吗？`,
          "删除资讯",
          {
            confirmButtonText: "删除资讯",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false
          }
        );
        this.deletingId = item.id;
        const resp = await deleteNews({ id: item.id });
        if (resp && resp.bizcode === 100) {
          if (this.list.length === 1 && this.listQuery.page > 1) {
            this.listQuery.page -= 1;
          }
          await this.getList();
          this.$notify({
            title: "成功",
            message: "资讯已删除",
            type: "success",
            duration: 2000
          });
        }
      } catch (error) {
        if (error !== "cancel" && error !== "close") {
          this.$message.error((error && error.message) || "删除资讯失败");
        }
      } finally {
        this.deletingId = null;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.content-preview {
  width: 280px;
  max-height: 72px;
  overflow: hidden;
  line-height: 22px;
  text-align: left;

  ::v-deep p {
    margin: 0;
  }

  ::v-deep img {
    display: inline-block;
    width: auto !important;
    height: auto !important;
    max-width: 72px;
    max-height: 56px;
    margin: 2px 4px;
    object-fit: contain;
    vertical-align: middle;
  }
}

.danger-action {
  color: #f56c6c;
}

.danger-action:hover,
.danger-action:focus {
  color: #f78989;
}
</style>
